import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const About = () => (
    <section className="pt-28 md:pt-44" data-testid="about-section">
        <SectionHeading index="05" title="About" id="about" />

        <div className="px-6 md:px-12 grid grid-cols-12">
            <Reveal className="col-span-12 md:col-span-8 md:col-start-3">
                <p className="text-xl sm:text-2xl md:text-4xl font-light leading-snug md:leading-snug" data-testid="about-statement">
                    I'm <span className="font-script text-[var(--red)] text-3xl md:text-5xl px-1">Marco Giavazzi</span> — a
                    designer with a background in <span className="font-medium">Fashion Design</span> and a Master's
                    degree in <span className="font-medium">Communication Design</span>. My work moves between visual
                    culture, narrative and identity — from garments to graphics, from objects to film.
                </p>
                <div className="mt-14 md:mt-16 border-t border-[var(--line)]" data-testid="about-education">
                    <div className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-1 py-6 md:py-7 border-b border-[var(--line)]" data-testid="about-degree-ma">
                        <span className="font-display text-lg sm:text-2xl md:text-3xl uppercase tracking-tight">
                            Communication Design
                        </span>
                        <span className="font-mono2 text-[10px] md:text-xs tracking-[0.2em] text-[var(--mute)] uppercase">
                            Università Iuav di Venezia
                        </span>
                        <span className="font-mono2 text-[10px] md:text-xs tracking-[0.2em] text-[var(--red)] uppercase whitespace-nowrap">
                            Master's degree — MA
                        </span>
                    </div>
                    <div className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-1 py-6 md:py-7 border-b border-[var(--line)]" data-testid="about-degree-ba">
                        <span className="font-display text-lg sm:text-2xl md:text-3xl uppercase tracking-tight">
                            Fashion and Accessories
                        </span>
                        <span className="font-mono2 text-[10px] md:text-xs tracking-[0.2em] text-[var(--mute)] uppercase">
                            Politecnico di Milano
                        </span>
                        <span className="font-mono2 text-[10px] md:text-xs tracking-[0.2em] text-[var(--red)] uppercase whitespace-nowrap">
                            Bachelor's degree — BA
                        </span>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
